import baseAPI from '../axiosApi'

const api={
    list:'/api-ir/teacher/book/page',
    add:'/api-ir/teacher/book/add',
    update:'/api-ir/teacher/book/edit',
    info:'/api-ir/teacher/book/info/',
    del:'/api-ir/teacher/book/delete/',
}
// 查询协议管理列表
export function list (data) {
    return baseAPI.axiosData(api.list,'get',data)
}
// 新增协议管理
export function add (data) {
    return baseAPI.axiosData(api.add,'post',data)
}
// 修改协议管理
export function update (data) {
    return baseAPI.axiosData(api.update,'put',data)
}
// 查询协议管理信息
export function info (id) {
    return baseAPI.axiosData(api.info+id,'get')
}
// 删除协议管理
export function del (id) {
    return baseAPI.axiosData(api.del+id,'delete')
}
